//ExtendedProductInformation modules
define(
	'EideBaillyLLP.ExtendedProductInformation', [],   
	function ()
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{			
			/** @type {ProductListPageComponent} */
			var plp = container.getComponent('PLP'),
			layout  = container.getComponent('Layout');

			if (plp && layout)
			{
				try 
				{
					// Brand
					layout.addToViewContextDefinition('Facets.ItemCell.View', 'productBrand', 'string', function productBrand (context) {
						var brand = '';
						if (plp.getItemsInfo()) 
						{
							var model = _.find(plp.getItemsInfo(), function (item)
							{
								return item.internalid == context.itemId;
							});

							brand = model.custitem_scbrand;
						}
						
						return brand == '&nbsp;' || brand == '' ? '' : brand;
					});

					// PartNumber
					layout.addToViewContextDefinition('Facets.ItemCell.View', 'productPartNumber', 'string', function productPartNumber (context) {
						var partNumber = '';
						if (plp.getItemsInfo()) 
						{
							var model = _.find(plp.getItemsInfo(), function (item)
							{
								return item.internalid == context.itemId;
							});

							partNumber = model.itemid;
						}

						return partNumber;
					});
				} 
				catch (e) 
				{
					console.error(e);
				}
 			}
		}
	};
});
